"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AccountEnvMenu = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));
var _react = _interopRequireWildcard(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));
var _reactIntl = require("react-intl");
var _classnames = _interopRequireDefault(require("classnames"));
var _copyTextToClipboard = _interopRequireDefault(require("../../utils/copyTextToClipboard"));
var _AuAnalytics = _interopRequireDefault(require("../../utils/AuAnalytics"));
var _AuButton = _interopRequireWildcard(require("../elements/AuButton"));
var _AutoIntl = _interopRequireDefault(require("../elements/AutoIntl"));
var _List = _interopRequireDefault(require("../elements/List"));
var _SelectableList = _interopRequireDefault(require("../elements/SelectableList"));
var _context, _context2, _context3, _context4;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "account_env_menu-module__container___IdxhC",
  "section": "account_env_menu-module__section____jKx5",
  "button": "account_env_menu-module__button___Ejrj8",
  "username_copied": "account_env_menu-module__username_copied___THUOf",
  "copied": "account_env_menu-module__copied___yEzLR",
  "account_container": "account_env_menu-module__account_container___mdLn5",
  "instance_container": "account_env_menu-module__instance_container___WvENy",
  "divider": "account_env_menu-module__divider___V9Zwq",
  "id": "account_env_menu-module__id___T1hwS",
  "name": "account_env_menu-module__name___MQ0bM",
  "account_name": "account_env_menu-module__account_name___QksJp account_env_menu-module__name___MQ0bM",
  "listvalue_id": "account_env_menu-module__listvalue_id___g9c8A",
  "title_container": "account_env_menu-module__title_container___FScbd",
  "toggle": "account_env_menu-module__toggle___SMgWB",
  "open": "account_env_menu-module__open___Q8Glx",
  "icon": "account_env_menu-module__icon___FTFkN",
  "account_icon": "account_env_menu-module__account_icon___zy8S2 account_env_menu-module__icon___FTFkN",
  "instance_icon": "account_env_menu-module__instance_icon___YuUr7 account_env_menu-module__icon___FTFkN",
  "account_list": "account_env_menu-module__account_list___veq8u",
  "hover": "account_env_menu-module__hover___hd8Fi"
};
class AccountEnvMenu extends _react.PureComponent {
  static propTypes = {
    accountId: T.string,
    accountName: T.string,
    partitions: T.array,
    accounts: (0, _map.default)(_reactImmutableProptypes.default),
    partition: T.string
  };
  constructor(props) {
    super(props);
    this.state = {
      envListIsOpen: false,
      acctListIsOpen: false,
      accountId: undefined,
      partition: '',
      accountName: ''
    };
  }
  get canSwitchPartition() {
    const {
      partitions
    } = this.props;
    return partitions && (0, _keys.default)(partitions).length > 1;
  }
  get canSwitchAccount() {
    const {
      accounts
    } = this.props;
    return accounts && accounts.size > 1;
  }
  selectAccount = (0, _bind.default)(_context = this.selectAccount).call(_context, this);
  selectAccount(account) {
    const {
      accountId
    } = this.props;
    _AuAnalytics.default.trackEvent({
      category: 'Account',
      action: 'Select',
      label: account.value
    });
    if (accountId && accountId !== this.state.accountId) {
      this.setState({
        accountId: account.value,
        accountName: account.displayString
      });
      this.props.setAccountId(account.value);
      location.reload();
    }
  }
  selectPartition = (0, _bind.default)(_context2 = this.selectPartition).call(_context2, this);
  selectPartition(partition) {
    const {
      setPartition
    } = this.props;
    _AuAnalytics.default.trackEvent({
      category: 'Partition',
      action: 'Select',
      label: partition.value
    });
    if (partition !== this.state.partition) {
      this.setState({
        partition: partition.value
      });
      setPartition(partition.value);
      location.reload();
    }
  }
  createAccountIdListItem(labelId, valueString) {
    let valueComponent;
    if (this.state[labelId] === valueString) {
      // id has been copied
      valueComponent = /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
        displayId: "au.userProfile.copiedToClipboard",
        className: styles.username_copied,
        tag: "div"
      });
    } else {
      const onClick = () => {
        (0, _copyTextToClipboard.default)(valueString);
        this.setState({
          [labelId]: valueString
        });
        (0, _setTimeout2.default)(() => this.setState({
          [labelId]: undefined
        }), 5000);
      };
      valueComponent = /*#__PURE__*/_react.default.createElement(_AuButton.default, {
        type: _AuButton.BUTTON_TYPE_PLAIN,
        displayId: "au.userProfile.copyToken",
        onClick: onClick,
        className: styles.button
      });
    }
    const el = /*#__PURE__*/_react.default.createElement("div", {
      className: styles.listvalue_id
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.id
    }, valueString), valueComponent);
    return {
      labelId,
      valueComponent: el
    };
  }
  renderAccount() {
    const {
      accountId
    } = this.props;
    const {
      acctListIsOpen
    } = this.state;
    if (!accountId) {
      return false;
    }
    const list = [this.createAccountIdListItem('au.userAccount.accountId', accountId)];
    return /*#__PURE__*/_react.default.createElement("div", {
      className: styles.section
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.account_container
    }, /*#__PURE__*/_react.default.createElement("div", {
      onClick: this.toggleAcctListOpen,
      className: (0, _classnames.default)(styles.account_icon, {
        [styles.hover]: this.canSwitchAccount
      })
    }, this.canSwitchAccount && /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.toggle, {
        [styles.open]: acctListIsOpen
      })
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.account_name
    }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      displayId: "au.acct",
      values: {
        acct: /*#__PURE__*/_react.default.createElement("span", {
          className: styles.labelvalue
        }, this.props.accountName)
      }
    }))), /*#__PURE__*/_react.default.createElement(_List.default, {
      list: list
    }));
  }
  toggleEnvListOpen = (0, _bind.default)(_context3 = this.toggleEnvListOpen).call(_context3, this);
  toggleEnvListOpen() {
    if (this.canSwitchPartition) {
      this.setState(prevState => ({
        envListIsOpen: !prevState.envListIsOpen
      }));
    }
  }
  toggleAcctListOpen = (0, _bind.default)(_context4 = this.toggleAcctListOpen).call(_context4, this);
  toggleAcctListOpen() {
    if (this.canSwitchAccount) {
      this.setState(prevState => ({
        acctListIsOpen: !prevState.acctListIsOpen
      }));
    }
  }
  renderEnvDropdown() {
    const {
      partitions
    } = this.props;
    const {
      envListIsOpen
    } = this.state;
    if (partitions.length === 0) {
      return false;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: styles.section
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.instance_container
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.instance_icon, {
        [styles.hover]: this.canSwitchPartition
      }),
      onClick: this.toggleEnvListOpen
    }, this.canSwitchPartition && /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.toggle, {
        [styles.open]: envListIsOpen
      })
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.account_name
    }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      displayId: "au.instance",
      values: {
        instance: /*#__PURE__*/_react.default.createElement("span", {
          className: styles.labelvalue
        }, this.props.partition)
      }
    }))));
  }
  render() {
    var _context5;
    const {
      envListIsOpen,
      acctListIsOpen
    } = this.state;
    const {
      partitions,
      accounts,
      accountName,
      partition,
      accountId
    } = this.props;
    const options = accounts && (0, _map.default)(_context5 = (0, _values.default)(accounts.toJS())).call(_context5, account => ({
      displayString: account.name,
      value: account.id
    }));
    let partitionValue;
    for (let i = 0; i < partitions.length; i++) {
      if (partitions[i].displayString === this.props.partition) {
        partitionValue = partitions[i].value;
        break;
      }
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: styles.container
    }, this.renderEnvDropdown(), this.canSwitchPartition && envListIsOpen && /*#__PURE__*/_react.default.createElement(_SelectableList.default, {
      canDeselect: false,
      items: partitions,
      defaultValue: partition,
      onChange: this.selectPartition,
      selection: [partitionValue]
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.divider
    }), this.renderAccount(), this.canSwitchAccount && acctListIsOpen && /*#__PURE__*/_react.default.createElement(_SelectableList.default, {
      canDeselect: false,
      items: options,
      defaultValue: accountName,
      onChange: this.selectAccount,
      selection: [accountId],
      className: styles.account_list
    }));
  }
}
exports.AccountEnvMenu = AccountEnvMenu;
class ConnectedAccountEnvMenu extends _react.PureComponent {
  render() {
    const {
      accountId,
      partition,
      showAccountDialog,
      onPartitionChange,
      onAccountChange,
      accounts,
      partitions,
      setAccountId
    } = this.props;
    const {
      accountName
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(AccountEnvMenu, (0, _extends2.default)({}, this.state, {
      accountId: accountId,
      accountName: accountName,
      showAccountDialog: showAccountDialog,
      partitions: partitions,
      partition: partition,
      accounts: accounts,
      onPartitionChange: onPartitionChange,
      onAccountChange: onAccountChange,
      setAccountId: setAccountId
    }));
  }
}
var _default = exports.default = (0, _reactIntl.injectIntl)(ConnectedAccountEnvMenu);